var Education = "Education";
var Enterprise = "Enterprise";
var CompanyType = {
	"Company type": "Company type",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "Government - Federal",
	"Government - State & local": "Government - State & local",
	"Non-profit": "Non-profit",
	"Self employed": "Self employed",
	"Small-medium business": "Small-medium business",
	"Start-up": "Start-up",
	"Not applicable": "Not applicable"
};

export { Education, Enterprise, CompanyType as default };
